import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import LandingAlt from "./pages/LandingAlt";
import LandingV3 from "./pages/LandingV3";
import ScanPreview from "./pages/ScanPreview";
import ScanIntake from "./pages/ScanIntake";
import QuoteCompare from "./pages/QuoteCompare";
import QuoteCompareShared from "./pages/QuoteCompareShared";
import LandingLegacy from "./pages/LandingLegacy";
import HowItWorks from "./pages/HowItWorks";
import Services from "./pages/Services";
import About from "./pages/About";
import Knowledge from "./pages/Knowledge";
import Installers from "./pages/Installers";
import FAQPage from "./pages/FAQPage";
import Portal from "./pages/Portal";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPricing from "./pages/AdminPricing";
import AdminMarket from "./pages/AdminMarket";
import MockupHome from "./pages/MockupHome";
import MockupIntake from "./pages/MockupIntake";
import MockupHomeV4 from "./pages/MockupHomeV4";
import QuoteRequest from "./pages/QuoteRequest";
import Legal from "./pages/Legal";
import PageTracker from "./PageTracker";function App() {
  return (
    <div className="App min-h-screen bg-[#F6F5F2] text-[#1C1B19]">
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<MockupHomeV4 />} />
          <Route path="/intake" element={<MockupIntake />} />
          <Route path="/v3-legacy" element={<LandingV3 />} />
          <Route path="/minimalist" element={<Landing />} />
          <Route path="/alternatief" element={<LandingAlt />} />
          <Route path="/v3" element={<MockupHome />} />
          <Route path="/v4" element={<MockupHomeV4 />} />
          <Route path="/offerte" element={<QuoteRequest />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/voorwaarden" element={<Legal type="terms" />} />
          <Route path="/scan" element={<ScanPreview />} />
          <Route path="/scan-intake" element={<ScanIntake />} />
          <Route path="/offertes-vergelijken" element={<QuoteCompare />} />
          <Route path="/vergelijking/:token" element={<QuoteCompareShared />} />
          <Route path="/legacy" element={<LandingLegacy />} />
          <Route path="/hoe-werkt-het" element={<HowItWorks />} />
          <Route path="/diensten" element={<Services />} />
          <Route path="/over-ons" element={<About />} />
          <Route path="/kennisbank" element={<Knowledge />} />
          <Route path="/voor-installateurs" element={<Installers />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/portal/payment" element={<PaymentSuccess />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/pricing" element={<AdminPricing />} />
          <Route path="/admin/market" element={<AdminMarket />} />
          <Route path="/mockup/home" element={<MockupHome />} />
          <Route path="/mockup/intake" element={<MockupIntake />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
